export const QUOTES_PATHS = {
  list: 'quotes'
};
